<template>
<el-container>
  <div v-if="common.isMobile() === false">
    <publicHeader ref="child" @hotelLanguage="hotelLanguage"></publicHeader>
  </div>
  <div v-else>
    <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
      <router-link :to="{name:'login', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}">
        <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
      </router-link>
      <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('createAccount')}}</div>
    </div>
  </div>
  <el-main :class="{'top-pc': common.isMobile() === false}">
      <div class="register-main">
        <div class="register-info">
          <div style="padding:6%;padding-bottom: 12%;">
            <div class="registertext">{{$t('createAccount')}}</div>
            <transition name="mybox">
              <div class="login-remind-faild" :class="{'faild': remindFaild}" v-show="remindFaild">
                <div class="login-remindinfo">
                  <div class="login-img-faild">
                    <img src="https://res.roompai.com/static/img/account/my-error.png" style="width:12px; height:12px;display: block;margin: 3px auto;">
                  </div>
                  <div class="login-remind-text-faild">
                    <span v-html="getLanguageHtml(remindMessage,'remindMessage')"></span></div>
                </div>
              </div>
            </transition>
            <transition name="mybox">
              <div class="login-remind-success" :class="{'faild': remindFaild}" v-show="remindSuccess">
                <div class="login-remindinfo">
                  <div class="login-img-success">
                    <img src="https://res.roompai.com/static/img/account/my-payment-yes.png" style="width:12px; height:12px;display: block;margin: 3px auto;">
                  </div>
                  <div class="login-remind-text-success">
                    <span v-html="getLanguageHtml(remindMessage,'remindMessage')"></span></div>
                </div>
              </div>
            </transition>
            <form class="el-form demo-ruleForm register-form">
              <div>
                <div class="register-name">{{$t('electronEmail')}}</div>
                <div class="el-form-item__content">
                  <div class="el-input">
                    <input type="text" autocomplete="off" class="el-input__inner" :class="{'codeError':emailError || emailSubDomainError}" ref="email" :placeholder="$t('electronEmail')" @blur="checkValue('email')">
                  </div>
                  <div class="el-form-item__error" v-show="emailSubDomainError">
                    <span v-html="getLanguageHtml(emailSubDomainErrorMsg,'remindMessage')"></span>
                  </div>
                </div>
              </div>
              <div style="margin-top:30px;">
                <div class="register-name">{{$t('lastName')}}</div>
                <div class="el-form-item__content">
                  <div class="el-input">
                    <input type="text" autocomplete="off" class="el-input__inner" :class="{'codeError':lastnameError}" ref="lastname" :placeholder="$t('lastName')">
                  </div>
                </div>
              </div>
              <div style="margin-top:30px;">
                <div class="register-name">{{$t('firstName')}}</div>
                <div class="el-form-item__content">
                  <div class="el-input">
                    <input type="text" autocomplete="off" class="el-input__inner" :class="{'codeError':firstnameError}" ref="firstname" :placeholder="$t('firstName')">
                  </div>
                </div>
              </div>
              <div style="margin-top:30px;">
                <div class="register-name">{{$t('password')}}</div>
                <div class="el-form-item__content">
                  <div class="el-input">
                    <el-input type="password" autocomplete="new-password" v-model="pwdInput" :placeholder="$t('password')" :class="{'codeError':passWordError}" show-password></el-input>
                  </div>
                </div>
              </div>
              <div style="margin-top:30px;">
                <div class="register-name">{{$t('retypePassword')}}</div>
                <div class="el-form-item__content">
                  <div class="el-input">
                    <el-input type="password" autocomplete="new-password" v-model="retypePassword" :placeholder="$t('password')" :class="{'codeError':passWordTwoError}" show-password></el-input>
                  </div>
                </div>
              </div>
              <div style="margin-top:40px;">
                <el-button  :class="{'register_send':!register_send_show, 'register_send_active':register_send_show}" @click="submitForm()" data-index="register-button">{{$t('createAccount')}}</el-button>
              </div>
            </form>
            <div class="register-other">
              <div style="float:right;">{{$t('alreadyHaveAnAccount')}}？
                <router-link :to="{name:'login', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}">
                  {{$t('signIn')}}
                </router-link>
              </div>
            </div>
            <authorizedLoginModule pageTitle="authorizedRegisterTitle"></authorizedLoginModule>
          </div>
        </div>
      </div>
  </el-main>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import { emailRegister } from '@/request/login.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import authorizedLoginModule from '@/components/login/module/authorizedLogin'

export default {
  name: 'register',
  components: {
    publicFooter,
    publicHeader,
    authorizedLoginModule
  },
  data () {
    return {
      send_email: '',
      emailError: false,
      lastnameError: false,
      firstnameError: false,
      passWordError: false,
      passWordTwoError: false,
      remindFaild: false,
      remindSuccess: false,
      register_send_show: false,
      remindMessage: 'emailOrPasswordIncorrect',
      source: 'roompai',
      language: this.common.languageSet(this),
      pwdInput: '',
      emailSubDomainError: false,
      emailSubDomainErrorMsg: '',
      lastEmailSubDomainBlocklist: '', // 记录最后调用接口返回一次性黑名单的邮箱.
      retypePassword: '',
      conver: ''
    }
  },
  beforeCreate () {
  },
  created: function () {
  },
  beforeDestroy () {
    document.removeEventListener('click', this.bodyCloseMenus)
  },
  mounted: function () {
    // 存储来源
    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    var conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
    // 判断是否登陆
    var token = localStorage.getItem('token')
    if (token !== null) {
      // this.$router.push({name: 'Home', query: {'source': this.source}})
      var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'Home', params: {'querys': newQuerys}})
    }
    // 下拉框关闭
    document.addEventListener('click', this.bodyCloseMenus)
  },
  methods: {
    checkValue (refInfo) {
      var refName = this.$refs[refInfo].value
      if (refName !== '' && refName !== null) {
        if (refInfo === 'email') {
          let emailSubDomain = refName.split('@')[1] || null
          var pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@([a-zA-Z0-9])(\.|\w|-)+\.([a-zA-Z]{2,})$/
          if (!pattern.test(refName)) {
            this.emailError = true
          } else if (emailSubDomain === this.lastEmailSubDomainBlocklist) {
            this.emailSubDomainError = true
            this.emailSubDomainErrorMsg = 'emailSubDomainBlocklist'
          } else {
            this.emailError = false
            this.emailSubDomainError = false
          }
        }
      }
    },
    submitForm () {
      this.register_send_show = true
      var email = this.$refs['email'].value
      var lastname = this.$refs['lastname'].value
      var firstname = this.$refs['firstname'].value
      var pwd = this.pwdInput
      var pwdt = this.retypePassword
      if (email === '' || email === null) {
        this.emailError = true
      } else {
        this.checkValue('email')
      }
      this.lastnameError = lastname === '' || lastname === null
      this.firstnameError = firstname === '' || firstname === null
      this.passWordError = pwd.length < 6
      this.passWordTwoError = pwd !== pwdt
      if (this.emailError === false && this.emailSubDomainError === false && this.lastnameError === false && this.firstnameError === false && this.passWordError === false && this.passWordTwoError === false) {
        var time = parseInt(new Date().getTime() / 1000)
        var searchHotelLocation = sessionStorage.getItem('search_hotel_location')
        var dataJson = {'email': email, 'lastname': lastname, 'firstname': firstname, 'password': pwd, 'passwordTwo': pwdt, 'time': time, 'source': this.source, 'language': this.language, 'searchHotelLocation': searchHotelLocation !== null ? searchHotelLocation : ''}
        if (this.conver === 1 || this.conver === '1') {
          dataJson = {'email': email, 'lastname': lastname, 'firstname': firstname, 'password': pwd, 'passwordTwo': pwdt, 'time': time, 'source': this.source, 'conver': this.conver, 'language': this.language, 'searchHotelLocation': searchHotelLocation !== null ? searchHotelLocation : ''}
        }
        var data = this.common.encryptionData(dataJson, this)
        emailRegister(data).then(res => {
          if (res.flag === '200') {
            this.send_email = email
            this.remindFaild = false
            this.remindSuccess = true
            // 注册成功，移出本地openid.
            localStorage.removeItem('weixin_bind_openid_new')
            sessionStorage.setItem('verifyEmailSendEmail', email)
            sessionStorage.removeItem('emailSendTips')

            // this.$router.push({name: 'login', query: {'source': this.source}})
            var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
            if (this.conver === 1 || this.conver === '1') {
              newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
            }
            this.$router.push({name: 'login', params: {'querys': newQuerys}})

            this.remindMessage = 'verifyEmailSendEmail'
          } else if (res.flag === '151') {
            this.remindFaild = true
            this.remindSuccess = false
            this.remindMessage = 'mailboxExistsNew'
          } else if (res.flag === '152') {
            this.remindFaild = true
            this.remindSuccess = false
            this.remindMessage = res.msg
          } else if (res.flag === '104') {
            this.lastEmailSubDomainBlocklist = email.split('@')[1] || null
            this.emailSubDomainError = true
            this.emailSubDomainErrorMsg = 'emailSubDomainBlocklist'
          } else if (res.flag === '102' || res.flag === '103') {
            this.$message({
              type: 'error',
              message: this.$t(res.msg)
            })
          } else {
            this.remindFaild = true
            this.remindSuccess = false
            this.remindMessage = 'emailOrPasswordIncorrect'
          }
        })
      }
    },
    getLanguageHtml: function (data, type) {
      if (data === undefined) {
        return ''
      }
      // var getLanguage = this.common.languageSet(this)
      if (['remindMessage'].includes(type)) {
        var remark = this.$t(data)
        if (data === 'verifyEmailSendEmail') {
          remark = this.$t(data) + ' ' + this.send_email
        }
        return remark
      }
    },
    bodyCloseMenus: function (node) {
      if (node.target.getAttribute('data-index') !== 'register-button') {
        if (this.register_send_show === true) {
          this.register_send_show = false
        }
      }
    },
    hotelLanguage (language) {
      this.language = language
    }
  }
}
</script>

<style scoped>
/deep/ .top-pc{margin-top: 60px;}
.register-main{background-color: rgb(255, 241, 180);width:100%;padding-bottom:10px; margin:0 auto;padding-top: 2%;padding-bottom: 2%;}
.register-info{margin: 0 auto;background-color: rgba(255, 255, 255, 1);border: none;-moz-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.09803921568627451); -webkit-box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);}
.registertext{font-weight: 650;font-size: 24px; height: 60px;background-color: rgba(255, 255, 255, 0);box-sizing: border-box;border-bottom: 1px solid rgba(221, 223, 226, 1);}
.register-form{margin:15px 0px; color:#606266;font-size: 14px;}
.register-form input{ margin-top:10px;}
.register_send{width: 100%;height: 44px; font-size:16px; background-color: rgba(79, 76, 76, 1);box-sizing: border-box;border: 1px solid rgba(79, 76, 76, 1);border-radius: 4px;-moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724);-webkit-box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);color: #FFFFFF;}
.register_send:hover{background-color: rgb(252, 210, 5, 1);border-color: rgb(252, 210, 5, 1); color:rgb(79,76,76)}
.register_send_active{width: 100%;height: 44px; font-size:16px; background-color: rgb(252, 210, 5, 1)!important;box-sizing: border-box;border: 1px solid rgba(79, 76, 76, 1)!important;border-radius: 4px;-moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724)!important;-webkit-box-shadow: 5px 5px 5px rgb(0 0 0 / 35%)!important;border-color: rgb(252, 210, 5, 1)!important;box-shadow: 5px 5px 5px rgb(0 0 0 / 35%)!important;color: rgb(79,76,76)!important;}
.register-other{ font-size:14px;height: 35px}
.register-other a{ color:#5392F9;text-decoration-line: none;}
.el-input.is-active .el-input__inner, .el-input__inner:focus{border-color:rgba(252,210,5,1);box-shadow:0px 0px 8px rgba(252,210,5);}
.codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border: 2px solid rgba(225, 45, 45, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
/deep/ .el-button:focus, .el-button:hover{color:rgb(79,76,76)!important;border-color:rgb(252, 210, 5, 1)!important;background-color:rgb(252, 210, 5, 1)!important;}

.login-remind-faild{overflow: hidden;background: inherit;background-color: rgba(254, 240, 240, 1);border-width: 0px;height: 56px;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.login-remind-success{overflow: hidden;background: inherit;background-color: #f0f9eb;border-width: 0px;height: 56px;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}

.login-img-faild{margin: 18px;width: 18px;height: 18px;background-color: rgba(245, 108, 108, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal; margin-right:10px;float: left;}
.login-img-success{margin: 18px;width: 18px;height: 18px;background-color: #67c23a;border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal; margin-right:10px;float: left;}

.login-remind-text-faild{color: #F56C6C;line-height: 20px; font-size:14px;width:75%;float: left;margin: 18px 0px;}
.login-remind-text-success{ color: #67c23a;line-height: 20px;font-size: 14px; width: 75%;float: left;margin: 10px 0px;}

.codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border: 2px solid rgba(225, 45, 45, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.mybox-leave-active,
.mybox-enter-active {
  transition: all 1s ease;
}

.mybox-leave-active,
.mybox-enter {
  height: 0px !important;
}

.mybox-leave,
.mybox-enter-active {
  height: 56px;
}
@media screen and (min-width: 1001px) {
.register-info{width: 500px;}
}
@media screen and (max-width: 1000px) {
.register-info{width: 97%;}
}
</style>



// WEBPACK FOOTER //
// src/components/login/register.vue